import { Component, OnInit, Input } from '@angular/core';
import { FranchiseService } from './franchise.service';
import { Franchise } from './franchise.model';
import { UntypedFormGroup, UntypedFormBuilder, FormControl, Validators } from '@angular/forms';
import { CustomValidators } from '../../../../core/custom-validators';
import { Router } from '@angular/router';


@Component({
  selector: 'app-franchise',
  templateUrl: './franchise.component.html',
  styleUrls: ['./franchise.component.css']
})
export class FranchiseComponent implements OnInit {

  formbuilder: any;
  formGroup: any;
  franchiseData: Franchise = new Franchise();
  franchiseForm: UntypedFormGroup;
  formgroup: UntypedFormGroup;
  completionPage: boolean;
  today: Date;
  allStates = [];
  constructor(private formBuilder: UntypedFormBuilder,
    private router: Router,
    private service: FranchiseService) { }


  public radioBtnOptions = [
    { value: '0', display: '0' },
    { value: '1', display: '1' },
    { value: '2', display: '2' },
    { value: '3', display: '3' },
    { value: '4', display: '4' }
  ];

  public radioBtn1Options = [ // Not sure option Added
    { value: '0', display: '0' },
    { value: '1', display: '1' },
    { value: '2', display: '2' },
    { value: '3', display: '3' },
    { value: '4', display: '4' },
    { value: 'Not Sure', display: 'Not Sure' }
  ];

  public yesNoOptions = [
    { value: 'Yes', display: 'Yes' },
    { value: 'No', display: 'No' }
  ];

  public paidOptions = [
    { value: 'Yes', display: 'Yes' },
    { value: 'No', display: 'No' },
    { value: 'Other', display: 'Other Explain:' }
  ];
  public surveyOptions = [
    { value: 'Yes', display: 'Yes' },
    { value: 'No', display: 'No' },
    { value: 'Unsure', display: 'Unsure' }
  ];

  public mask = '(000) 000-0000';
  ngOnInit() {

    this.franchiseForm = this.formBuilder.group({
      franchiseEntity: [null, Validators.compose([Validators.required, CustomValidators.noSpace])],
      contactPerson: [null, Validators.compose([Validators.required, CustomValidators.noSpace])],
      city: [null, Validators.compose([Validators.required, CustomValidators.noSpace])],
      address1: [null, Validators.compose([Validators.required, CustomValidators.noSpace])],
      address2: null,
      zip: [null, Validators.compose([Validators.required, CustomValidators.zipCodeInvalid, CustomValidators.noSpace])],
      emailId: [null, Validators.compose([Validators.required , CustomValidators.validEmail, CustomValidators.noSpace])],
      state: [null, Validators.compose([Validators.required, CustomValidators.noSpace])],
      county: [null, Validators.compose([Validators.required, CustomValidators.noSpace])],
      phoneNumber: [null, Validators.compose([Validators.required, CustomValidators.PhoneNumberValid, CustomValidators.noSpace])],
      question1: [null, Validators.required],
      question2Comcast: null,
      question2Charter: null,
      question2Att: null,
      question2Other: null,
      question2Comment: null,
      question3: [null, Validators.required],
      question4: [null, Validators.required],
      question5Dish: [null, CustomValidators.noSpace],
      question5Direct: [null, CustomValidators.noSpace],
      question5Other: [null, CustomValidators.noSpace],
      question5Comment: [null, CustomValidators.noSpace],
      question6: [null, Validators.required],
      question7: [null, Validators.required],
      question7a: [null, Validators.compose([CustomValidators.numeric, CustomValidators.noSpace])],
      question7b: [null, CustomValidators.noSpace],
      question7c: [null, Validators.compose([CustomValidators.numeric, CustomValidators.noSpace])],
      Question7dRates: [null, CustomValidators.noSpace],
      question7dCustomer: [null, CustomValidators.noSpace],
      question7dBilling: [null, CustomValidators.noSpace],
      question7dService: [null, CustomValidators.noSpace],
      question7dOther: [null, CustomValidators.noSpace],
      question7dComment: [null, CustomValidators.noSpace],
      question8: [null, Validators.required],
      question9: [null, Validators.required],
      question10: [null, Validators.required],
      question10Franchise: [null, CustomValidators.noSpace],
      question10Agreement: [null, CustomValidators.noSpace],
      question10Peg: [null, CustomValidators.noSpace],
      question10Filling: [null, CustomValidators.noSpace],
      question10Other: [null, CustomValidators.noSpace],
      question10Comment: [null, CustomValidators.noSpace],
      question11: [null, Validators.required],
      question12Competition: [null, Validators.required],
      question12Franchise: [null, Validators.required],
      question12Peg: [null, Validators.required],
      question12Complaints: [null, Validators.required],
      question12Other: [null, CustomValidators.noSpace],
      question12Comment: [null, CustomValidators.noSpace],
      question13Customer: [null, Validators.required],
      question13Peg: [null, Validators.required],
      question13Services: [null, Validators.required],
      question13ServiceCenter: [null, Validators.required],
      question13Other: [null, CustomValidators.noSpace],
      question13Comment: [null, CustomValidators.noSpace],
      question14: [null, Validators.required],
      question15: [null, Validators.required],
      question16: [null, CustomValidators.validEmail],
      question18: null
    });

    this.getAllStates();
    this.completionPage = false;
    this.today = new Date();
    this.franchiseData.state = 'Michigan';
    this.franchiseData.question2Comment = null;
    this.franchiseData.question5Comment = null;
    this.franchiseData.question10Comment = null;
    this.franchiseData.franchiseEntity = null;
    this.franchiseData.contactPerson = null;
    this.franchiseData.address1 = null;
    this.franchiseData.city = null;
    this.franchiseData.county = null;
    this.franchiseData.zip = null;
    this.franchiseData.phoneNumber = null;
    this.franchiseData.emailId = null;
    this.franchiseData.address2 = "";
    this.franchiseData.question18 = null;
    this.franchiseData.question17 = "";
    this.franchiseData.question13Comment = null;
    this.franchiseData.question12Comment = null;
    this.franchiseData.question7a = null;
    this.franchiseData.question7b = null;
    this.franchiseData.question7c = null;
    this.franchiseData.question2Comcast = 'No';
    this.franchiseData.question2Charter = 'No';
    this.franchiseData.question2Att = 'No';
    this.franchiseData.question2Other = 'No';
    this.franchiseData.question5Dish = 'No';
    this.franchiseData.question5Direct = 'No';
    this.franchiseData.question5Other = 'No';
    this.franchiseData.Question7dRates = 'No';
    this.franchiseData.question7dCustomer = 'No';
    this.franchiseData.question7dBilling = 'No';
    this.franchiseData.question7dService = 'No';
    this.franchiseData.question7dOther = 'No';
    this.franchiseData.question7dComment = null;
    this.franchiseData.question10Franchise = 'No';
    this.franchiseData.question10Agreement = 'No';
    this.franchiseData.question10Peg = 'No';
    this.franchiseData.question10Filling = 'No';
    this.franchiseData.question10Other = 'No';
    this.franchiseData.question12Competition = null;
    this.franchiseData.question12Franchise = null;
    this.franchiseData.question12Peg = null;
    this.franchiseData.question12Complaints = null;
    this.franchiseData.question12Comment = null;
    this.franchiseData.question13Customer = null;
    this.franchiseData.question13Peg = null;
    this.franchiseData.question13Services = null;
    this.franchiseData.question13ServiceCenter = null;
    this.franchiseData.question13Comment = null;
    // this.franchiseForm.get('question16').valueChanges.subscribe(data => this.onEmailValueChanged(data));
  }


  checkQuestion2(checked) {
    if (checked) {
      this.franchiseData.question2Other = 'Yes';
    } else {
      this.franchiseData.question2Other = 'No';
      this.franchiseData.question2Comment = null;
    }
  }

  checkQuestion5(checked) {
    if (checked) {
      this.franchiseData.question5Other = 'Yes';
    } else {
      this.franchiseData.question5Other = 'No';
      this.franchiseData.question5Comment = null;
    }
  }

  checkQuestion10(checked) {
    if (checked) {
      this.franchiseData.question10Other = 'Yes';
    } else {
      this.franchiseData.question10Other = 'No';
      this.franchiseData.question10Comment = null;
    }
  }

  disabledQ10Fields() {
    if (this.franchiseData.question10 !== 'Yes') {
      this.franchiseData.question10Franchise = 'No';
      this.franchiseData.question10Agreement = 'No';
      this.franchiseData.question10Peg = 'No';
      this.franchiseData.question10Other = 'No';
      this.franchiseData.question10Filling = 'No';
    }
  }

  resetQuestion7() {
    if (this.franchiseData.question7 !== 'Yes') {
      this.franchiseData.question7a = null;
      this.franchiseData.question7c = null;
      this.franchiseData.question7b = null;
      this.franchiseData.Question7dRates = 'No';
      this.franchiseData.question7dCustomer = 'No';
      this.franchiseData.question7dBilling = 'No';
      this.franchiseData.question7dService = 'No';
      this.franchiseData.question7dOther = 'No';
      this.franchiseData.question7dComment = null;

    }
  }

  checkRequired() {

    if ((this.franchiseData.question2Other === 'No'
      && this.franchiseData.question2Comcast === 'No'
      && this.franchiseData.question2Charter === 'No'
      && this.franchiseData.question2Att === 'No')
      // 5
      || (this.franchiseData.question5Dish === 'No'
        && this.franchiseData.question5Direct === 'No'
        && this.franchiseData.question5Other === 'No'
      )
      || (this.franchiseData.question10 === 'Yes'
        && this.franchiseData.question10Franchise === 'No'
        && this.franchiseData.question10Agreement === 'No'
        && this.franchiseData.question10Peg === 'No'
        && this.franchiseData.question10Other === 'No'
        && this.franchiseData.question10Filling === 'No'
      )
      || (this.franchiseData.question7 === 'Yes'
        && this.franchiseData.Question7dRates === 'No'
        && this.franchiseData.question7dCustomer === 'No'
        && this.franchiseData.question7dBilling === 'No'
        && this.franchiseData.question7dService === 'No'
        && this.franchiseData.question7dOther === 'No')
      ||
        (this.franchiseData.question7 === 'Yes'
        && !this.franchiseData.question7a
        && !this.franchiseData.question7c
        && this.franchiseData.question7b === 'No')
      ||
      (this.franchiseData.question2Other === 'Yes' &&
        (this.franchiseData.question2Comment === null ||
          this.franchiseData.question2Comment === 'undefined'
          || this.franchiseData.question2Comment === '')) ||
      (this.franchiseData.question10Other === 'Yes'
        && (this.franchiseData.question10Comment === '' ||
          this.franchiseData.question10Comment === 'undefined' ||
          this.franchiseData.question10Comment === null)
      ) ||
      (this.franchiseData.question5Other === 'Yes'
        && (this.franchiseData.question5Comment === '' ||
          this.franchiseData.question5Comment === 'undefined' ||
          this.franchiseData.question5Comment === null))
    ) {
      return true;
    } else {
      return false;
    }
  }

  save() {
    if (!this.franchiseForm.valid || this.checkRequired()) {
      Object.keys(this.franchiseForm.controls).forEach(key => {
        this.franchiseForm.get(key).markAsTouched();
      });
    } else {
      this.service.SaveVideoFranchise(this.franchiseData).subscribe(taxData => {
        if (taxData) {
          this.completionPage = true;
        } else {
          this.completionPage = false;
        }
      });
    }

  }

  getAllStates() {
    this.service.GetStates('').subscribe(statesData => {
      if (statesData) {
        this.allStates = statesData;
        this.completionPage = false;
      }
    });
  }

  goBack() {
    this.completionPage = false;
    this.franchiseData = new Franchise();
    Object.keys(this.franchiseForm.controls).forEach(key => {
      this.franchiseForm.get(key).markAsUntouched();
    });
    this.ngOnInit();
  }

  Menu() {
    this.router.navigateByUrl('/forms-home');
  }

}
